import * as React from "react";

const IconFooterLivechat: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="currentColor">
            <path
                fill="currentColor"
                d="M2.57304662,9.04531217 L2.37617171,9.5703125 L1.875781,10.9046872 L4.29570329,10.1773432 L4.55000025,10.1007811 L4.80156267,10.1773432 C5.48242187,10.3851559 6.22070312,10.4972655 6.99726588,10.4972655 C10.557422,10.4972655 13.1222663,8.18125033 13.1222663,5.68476546 C13.1222663,3.18828058 10.5574229,0.872265458 6.99726629,0.872265458 C3.43710971,0.872265458 0.875,3.19101596 0.875,5.6875 C0.875,6.77851546 1.34257829,7.80937517 2.17656267,8.64609408 L2.57304704,9.045313 L2.57304662,9.04531217 Z M1.49023438,11.9328123 L0.4375,12.25 L0.823047042,11.2218748 L1.55585963,9.26679671 C0.582421958,8.28789079 0,7.04375017 0,5.6875 C0,2.54570329 3.13359392,0 7,0 C10.8664061,0 14,2.54570329 14,5.6875 C14,8.82929671 10.8664061,11.375 7,11.375 C6.13867188,11.375 5.31289071,11.2492186 4.54999983,11.0167967 L1.49023438,11.9328123 Z"
                transform="translate(0 .625)"
            />
        </svg>
    );
};

export default React.memo(IconFooterLivechat);
